const countdown = (node, starter = 5) => {
  node.innerText = starter;
  let interval = setInterval(() => {
    starter -= 1;
    node.innerText = starter;
  }, 1000);
  setTimeout(() => clearInterval(interval), starter * 1000);
};
export default countdown;
